<template>
  <van-popup
    v-model="modelValue"
    v-bind="$attrs"
    v-on="$listeners"
    lock-scroll
    get-container="body"
    position="bottom"
    class="transparent__popup"
    @open="openPopup"
    @close="closedPopup"
  >
    <div :class="[isStore && 'isStore', 'popup-wrapper']">
      <div class="line"></div>
      <div class="main-wrapper">
        <div class="header">
          <div>筛选· {{ filterNumber }}</div>
          <div v-show="filterNumber > 0" class="reset-btn" @click="resetClick">
            重置
          </div>
        </div>
        <div class="select-main">
          <div
            v-for="(item, index) in filterPanelOptsData"
            :key="index"
            class="select-block"
          >
            <template v-if="'labelOptions' in item">
              <div
                v-for="(labelOpt, labelOptIndex) in item.labelOptions"
                :key="labelOptIndex"
                class="select-block"
              >
                <div class="select-label">
                  {{ labelOpt.name }}
                  <TipPop
                    v-if="item.tipWord"
                    :tipWord="item.tipWord"
                    max-w="60vw"
                    :placement="item.tipPlacement"
                    :ref="'tipPopRef' + index"
                    @click.native="showTip(index, item)"
                    :tipPopoverHeight="item.tipPopoverHeight"
                  ></TipPop>
                </div>
                <div class="select-group">
                  <div
                    class="select-cell"
                    :class="[
                      item.filterSelectedLabelOpt === labelOpt.value &&
                      item.selectedList.includes(subItem.value)
                        ? 'active'
                        : '',
                    ]"
                    v-for="(subItem, subIndex) in item.options"
                    :key="subIndex"
                    @click="clickSelectCell(item, subItem, labelOpt.value)"
                  >
                    {{ subItem.name }}
                  </div>
                </div>
                <div
                  class="custom-date-cell"
                  :class="[
                    item.filterSelectedLabelOpt === labelOpt.value &&
                    item.selectedList.includes(OTHER_TYPE.CUSTOM_DATE)
                      ? 'active'
                      : '',
                  ]"
                  v-if="
                    item.filterSelectedLabelOpt === labelOpt.value &&
                    item.filterType === FILTER_PANEL_OPT_TYPE.DATE &&
                    item.selectedList.includes(OTHER_TYPE.CUSTOM_DATE)
                  "
                  @click="openCustomDateTimePopup(item, index)"
                >
                  <div>{{ customDateStr(item)[0] }}</div>
                  <div>至</div>
                  <div>{{ customDateStr(item)[1] }}</div>
                </div>
              </div>
            </template>
            <template v-if="!('labelOptions' in item)">
              <div class="select-label">
                {{ item.label }}
                <TipPop
                  v-if="item.tipWord"
                  :tipWord="item.tipWord"
                  max-w="60vw"
                  :placement="item.tipPlacement"
                  :ref="'tipPopRef' + index"
                  @click.native="showTip(index, item)"
                  :tipPopoverHeight="item.tipPopoverHeight"
                ></TipPop>
              </div>
              <div class="select-group">
                <div
                  class="select-cell"
                  :class="[
                    item.selectedList.includes(subItem.value) ? 'active' : '',
                  ]"
                  v-for="(subItem, subIndex) in item.options"
                  :key="subIndex"
                  @click="clickSelectCell(item, subItem)"
                >
                  {{ subItem.name }}
                </div>
              </div>
              <div
                class="custom-date-cell"
                :class="[
                  item.selectedList.includes(OTHER_TYPE.CUSTOM_DATE)
                    ? 'active'
                    : '',
                ]"
                v-if="
                  item.filterType === FILTER_PANEL_OPT_TYPE.DATE &&
                  item.selectedList.includes(OTHER_TYPE.CUSTOM_DATE)
                "
                @click="openCustomDateTimePopup(item, index)"
              >
                <div>{{ customDateStr(item)[0] }}</div>
                <div>至</div>
                <div>{{ customDateStr(item)[1] }}</div>
              </div>
            </template>
          </div>
        </div>
        <div v-if="!hideButtonBar" class="bottom-bar">
          <span
            @click="modelValue = false"
            class="button"
            :style="storePlainBgStyle"
          >
            {{ cancelText }}
          </span>
          <span
            @click="handleConfirm"
            class="button active"
            :style="storeBgStyle"
          >
            {{ activeText }}
          </span>
        </div>
      </div>
    </div>
    <CustomDateTimePopup
      :dateType="curOption.dateType"
      v-model="dateTimePopup"
      :beginDate="curOption.curCustomDate[0]"
      :overDate="curOption.curCustomDate[1]"
      :limitDay="curOption.limitDay"
      @confirm="handleConfirmDateTime"
      :sameYear="false"
    />
  </van-popup>
</template>

<script>
// 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
import { cloneDeep } from 'lodash'
import TipPop from './TipPop.vue'
import CustomDateTimePopup from './CustomDateTimePopup.vue'
import moment from 'moment'
import { arraysAreEqual, formatStr } from '../utils'
import {
  FILTER_PANEL_OPT_TYPE,
  OTHER_TYPE,
  SEARCH_BOX_TYPE,
} from '@/components/VzanSearchBox/enum'
export default {
  name: 'FilterPanelPopup',
  components: { CustomDateTimePopup, TipPop },
  props: {
    value: {
      default: false,
      type: Boolean,
    },
    cancelText: {
      type: String,
      default: () => {
        return '取消'
      },
    },
    activeText: {
      type: String,
      default: () => {
        return '筛选'
      },
    },
    hideButtonBar: Boolean,
  },
  data() {
    return {
      FILTER_PANEL_OPT_TYPE,
      curOption: {
        curCustomDate: [],
      }, // 临时存储当前选中项（自定义日期）
      dateTimePopup: false,
      filterPanelOptsData: [],
      filterLinkageMap: new Map(),
      filterPropsMap: new Map(),
    }
  },
  computed: {
    OTHER_TYPE() {
      return OTHER_TYPE
    },
    modelValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    // * 当前是否门店系统客户模块
    isStore() {
      return StoreController.isStore()
    },
    storeBgStyle() {
      return StoreController.bgStyle()
    },
    storePlainBgStyle() {
      return StoreController.plainBgStyle()
    },
    storeBorderStyle() {
      return StoreController.borderStyle()
    },
    filterNumber() {
      let number = 0
      this.filterPanelOptsData.forEach(item => {
        if (!arraysAreEqual(item.selectedList, item.defaultSelectedList)) {
          number += 1
        }
      })
      return number
    },
  },
  watch: {
    filterNumber(val) {
      this.$emit('filterNumberChange', val)
    },
  },
  methods: {
    init(filterPanelOpts) {
      this.filterPanelOptsData = cloneDeep(filterPanelOpts)
      this.initData()
      this.filterPanelOptsData.forEach(item => {
        if ('groupId' in item) {
          this.filterLinkageMap.set(item.groupId, item)
        }
        item.defaultSelectedList = [] // 初始化一个空数组给默认选中项存放，为了区分是否更改了选择
        item.options.forEach(subItem => {
          if (subItem.default) {
            item.defaultSelectedList.push(subItem.value)
          }
        })
        if (item.defaultSelectedList.length === 0) {
          item.defaultSelectedList.push(item.options[0]?.value)
        }
        // 联动筛选项在父组件处理了
        if (!('groupId' in item)) {
          this.saveFilterPropsMap(item)
        }
      })
    },
    saveFilterPropsMap(item) {
      switch (item.filterType) {
        case FILTER_PANEL_OPT_TYPE.DATE:
          if ('labelOptions' in item) {
            item.labelOptions.forEach(labelOpt => {
              this.filterPropsMap.set(labelOpt.value, item)
            })
          } else {
            this.filterPropsMap.set(item.props, item)
          }
          break
        default:
          this.filterPropsMap.set(item.props, item)
          break
      }
    },
    setDefaultFilterOptions(paramsResult) {
      for (const paramsResultKey in paramsResult) {
        let item = this.filterPropsMap.get(paramsResultKey)
        if (!item) continue
        switch (item.filterType) {
          case FILTER_PANEL_OPT_TYPE.DATE:
            let labelOptValue = ''
            let subItem = {}
            if ('labelOptions' in item) {
              for (let i = 0; i < item.labelOptions.length; i++) {
                if (paramsResultKey === item.labelOptions[i].value) {
                  labelOptValue = item.labelOptions[i].value
                  break
                }
              }
              for (let i = 0; i < item.options.length; i++) {
                let isEqual = arraysAreEqual(
                  paramsResult[paramsResultKey],
                  item.options[i].value
                )
                if (isEqual) {
                  subItem = item.options[i]
                  // this.$set(item, 'selectedList', [paramsResult[paramsResultKey]])
                  break
                } else if (item.options[i].value === OTHER_TYPE.CUSTOM_DATE) {
                  subItem = item.options[i]
                  // this.$set(item, 'selectedList', [OTHER_TYPE.CUSTOM_DATE])
                  this.$set(
                    item,
                    'curCustomDate',
                    paramsResult[paramsResultKey]
                  )
                }
              }
              this.clickSelectCell(item, subItem, labelOptValue)
            } else {
              for (let i = 0; i < item.options.length; i++) {
                let isEqual = arraysAreEqual(
                  paramsResult[paramsResultKey],
                  item.options[i].value
                )
                if (isEqual) {
                  // this.$set(item, 'selectedList', [paramsResult[paramsResultKey]])
                  this.clickSelectCell(item, item.options[i])
                  break
                } else if (item.options[i].value === OTHER_TYPE.CUSTOM_DATE) {
                  this.$set(item, 'selectedList', [OTHER_TYPE.CUSTOM_DATE])
                  this.$set(
                    item,
                    'curCustomDate',
                    paramsResult[paramsResultKey]
                  )
                }
              }
            }
            break
          default:
            if (paramsResultKey === item.props) {
              this.$set(item, 'selectedList', paramsResult[paramsResultKey])
            }
            break
        }
      }
    },
    // 打开自定义时间选择弹窗
    openCustomDateTimePopup(item, index) {
      this.dateTimePopup = true
      let find = item.options.find(
        item => item.value === OTHER_TYPE.CUSTOM_DATE
      )
      this.curOption = {
        ...item,
        defaultBeginDate: find.defaultBeginDate,
        defaultEndDate: find.defaultEndDate,
        index: index,
      }
    },
    // 模板显示自定义时间
    customDateStr(item) {
      let startTime = moment(item.curCustomDate[0] || new Date()).format(
        formatStr(item.dateType)
      )
      let endTime = moment(item.curCustomDate[1] || new Date()).format(
        formatStr(item.dateType)
      )
      return [startTime, endTime]
    },
    // 自定义时间选择确认
    handleConfirmDateTime(date) {
      let startTime = moment(date[0])
      let endTime = moment(date[1])
      // 为其拼接秒
      if (endTime.seconds() === 0 && this.curOption.dateType === 'datetime') {
        endTime.seconds(59)
      }
      const format = formatStr(this.curOption.dateType)
      const formattedStartTime = startTime.format(format)
      const formattedEndTime = endTime.format(format)
      this.$set(
        this.filterPanelOptsData[this.curOption.index],
        'curCustomDate',
        [formattedStartTime, formattedEndTime]
      )
    },
    // 关闭弹窗
    closedPopup() {
      this.filterPanelOptsData.forEach(item => {
        this.$set(item, 'selectedList', [...item.preSelectedList])
      })
    },
    openPopup() {
      this.filterPanelOptsData.forEach(item => {
        this.$set(item, 'preSelectedList', [...item.selectedList])
      })
    },
    // 计算高度，展示提示
    showTip(index, item) {
      if (item.tipPlacement.includes('top')) {
        this.$set(
          item,
          'tipPopoverHeight',
          this.$refs['tipPopRef' + index][0].$el.getBoundingClientRect().top -
            10
        )
      } else {
        this.$set(
          item,
          'tipPopoverHeight',
          document.body.clientHeight -
            this.$refs['tipPopRef' + index][0].$el.getBoundingClientRect().top -
            30
        )
      }
      this.$nextTick(() => {
        this.$refs['tipPopRef' + index][0].show()
      })
    },
    // 重置
    async resetClick() {
      await this.initData()
    },
    // 初始化数据
    initData() {
      return new Promise(resolve => {
        this.filterPanelOptsData.forEach(item => {
          if ('labelOptions' in item) {
            let labelOption =
              item.labelOptions.find(labelOpt => labelOpt.default) ||
              item.labelOptions[0]
            this.$set(item, 'filterSelectedLabelOpt', labelOption.value) // 互斥选项，filterSelectedLabelOpt 新字段表示当前选中项(多选场景下用到)
          }
          this.$set(item, 'selectedList', []) // 初始化一个空数组给所选项存放
          if (item.filterType === FILTER_PANEL_OPT_TYPE.DATE) {
            this.$set(item, 'curCustomDate', []) // 针对自定义时间，初始化一个空数组给自定义时间存放
          }
          item.options.forEach(subItem => {
            if (
              item.filterType === FILTER_PANEL_OPT_TYPE.DATE &&
              subItem.value === OTHER_TYPE.CUSTOM_DATE
            ) {
              item.curCustomDate = [
                subItem.defaultBeginDate,
                subItem.defaultEndDate,
              ]
            }
            if (subItem.default) {
              item.selectedList.push(subItem.value)
            }
          })
          if (item.selectedList.length === 0) {
            item.selectedList.push(item.options[0]?.value)
          }
        })
        resolve()
      })
    },
    // 筛选面板确认
    async handleConfirm() {
      this.filterPanelOptsData.forEach(item => {
        if ('groupId' in item) {
          this.$emit(
            'changeOutSideBox',
            item.groupId,
            item.selectedList,
            item.curCustomDate,
            item
          )
        }
      })
      this.modelValue = false
      const res = await this.getData()
      this.$emit('confirm', res, this.filterNumber)
    },
    // 获取数据
    getData() {
      return new Promise(resolve => {
        const res = {}
        this.filterPanelOptsData.forEach(item => {
          this.$set(item, 'preSelectedList', [...item.selectedList])
          if ('labelOptions' in item) {
            if (
              item.filterType === FILTER_PANEL_OPT_TYPE.DATE &&
              item.selectedList[0] === OTHER_TYPE.CUSTOM_DATE
            ) {
              res[item.filterSelectedLabelOpt] = item.curCustomDate
            } else {
              res[item.filterSelectedLabelOpt] = item.selectedList[0]
            }
          } else {
            res[item.props] = item.selectedList
            if (item.filterType === FILTER_PANEL_OPT_TYPE.DATE) {
              if (item.selectedList[0] === OTHER_TYPE.CUSTOM_DATE) {
                res[item.props] = item.curCustomDate
              } else {
                res[item.props] = item.selectedList[0] // 时间格式 要取第一个
              }
            }
            if (
              item.groupId &&
              item.type === SEARCH_BOX_TYPE.SELECT &&
              item.multiple === false
            ) {
              // 单选情况下，同步联动配置单选时候是不array， 不是联动情况下 单选依旧为array
              res[item.props] = item.selectedList[0]
            }
          }
        })
        resolve(res)
      }).catch(err => {
        console.error(err)
      })
    },
    // 改变联动筛选项
    changeFilterBox(groupId, selectValue, curCustomDate, item) {
      let groupItem = this.filterLinkageMap.get(groupId)
      if (groupItem.filterType === FILTER_PANEL_OPT_TYPE.DATE) {
        let find = groupItem.options.find(opt => {
          return arraysAreEqual(opt.value, selectValue)
        })
        if (find.value === OTHER_TYPE.CUSTOM_DATE) {
          groupItem.curCustomDate = curCustomDate
        }
        this.clickSelectCell(groupItem, find, item.selectLabelValue)
      } else {
        if (item.multiple) {
          groupItem.selectedList = []
          selectValue.forEach(cur => {
            let find = item.options.find(opt => opt.value === cur)
            if (find) {
              this.clickSelectCell(groupItem, find, item.selectLabelValue)
            }
          })
        } else {
          let find = item.options.find(opt => opt.value === selectValue)
          if (find) {
            this.clickSelectCell(groupItem, find, item.selectLabelValue)
          }
        }
      }
    },
    // 选择点击
    clickSelectCell(item, subItem, labelOptValue) {
      // 一级选项，filterSelectedLabelOpt 新字段表示当前选中项
      if ('labelOptions' in item) {
        if (item.filterSelectedLabelOpt !== labelOptValue) {
          item.selectedList = []
        }
        this.$set(item, 'filterSelectedLabelOpt', labelOptValue)
      }
      if (item.multiple) {
        // 先清除“全部”选项
        let find = item.options.find(i => {
          return i.isAll || (!i.isAll && i.value === '')
        })
        if (find) {
          item.selectedList.forEach((selectedItem, index) => {
            if (selectedItem === find.value) {
              item.selectedList.splice(index, 1)
            }
          })
        }
        // 选择全部
        if (subItem.isAll || (!subItem.isAll && subItem.value === '')) {
          this.$set(item, 'selectedList', [subItem.value])
          return
        }
        if (item.selectedList.includes(subItem.value)) {
          // 只有一个的时候 不能取消
          if (
            item.selectedList.length === 1 &&
            item.selectedList[0] === subItem.value
          ) {
            return
          }
          item.selectedList = item.selectedList.filter(i => i !== subItem.value)
        } else {
          item.selectedList.push(subItem.value)
        }
      } else {
        if (
          item.filterType === FILTER_PANEL_OPT_TYPE.DATE &&
          subItem.value === OTHER_TYPE.CUSTOM_DATE
        ) {
          // todo
        }
        this.$set(item, 'selectedList', [subItem.value])
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../css/mixin.scss';
.main-wrapper {
  * {
    box-sizing: border-box;

    &::before,
    &::after {
      box-sizing: border-box;
    }
  }
}
::v-deep {
  .search input {
    font-size: 14px;
    font-size: var(--set-font-size14);
  }
}
.transparent__popup {
  max-height: 80%;
  overflow: auto;
  background: transparent !important;
}
.img-icon {
  width: 100px;
  height: 100px;
}
.popup-wrapper {
  width: 100%;
  height: 100%;
  .line {
    width: 40px;
    height: 4px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 2px;
    margin: 0 auto 10px;
  }
}
.bottom-bar {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #ffffff;
  display: flex;
  align-items: center;
  border-top: 1px solid #edeff2;
  gap: 10px;
  .button {
    flex: 1;
    height: 50px;
    background: #f0f7fe;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #006cff;
    line-height: 14px;
    font-size: var(--set-font-size14);
    line-height: 1;
    text-align: center;
    border-radius: 12px 12px 12px 12px;
    &.active {
      color: #fff;
      background: linear-gradient(270deg, #00a5ff 0%, #006cff 100%);
    }
  }
}
.isStore {
  .bottom-bar {
    .button {
      background: rgba(255, 241, 241, 1) !important;
      color: rgba(255, 68, 68, 1) !important;
      &.active {
        color: #fff !important;
        background: linear-gradient(90deg, #ff6300 0%, #ff2727 100%) !important;
      }
    }
  }
}
.main-wrapper {
  position: relative;
  background: #fff;
  padding: 20px 16px 10px;
  border-radius: 18px 18px 0px 0px;
  box-sizing: border-box;
  max-height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  font-size: 10px;
  font-size: var(--set-font-size10);
  color: #202124;
  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    font-size: var(--set-font-size16);
    color: #202124;
    line-height: 24px;
    margin-bottom: 20px;
    .reset-btn {
      color: #006cff;
    }
  }
  .select-main {
    -webkit-overflow-scrolling: touch;
    overflow: auto;
    width: 100%;
    margin-bottom: 10px;
    .select-block {
      margin-bottom: 20px;
    }
    .select-block:last-child {
      margin-bottom: 0;
    }
    .select-label {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      font-size: var(--set-font-size14);
      color: #202124;
      line-height: 22px;
      margin-bottom: 10px;
    }
    .select-group {
      margin: 1px;
      @include flex(
        $justify: flex-start,
        $align: center,
        $gap: 9px,
        $wrap: wrap
      );
    }
    .custom-date-cell {
      @include flex($justify: space-evenly, $align: center);
      margin-top: 9px;
      padding: 6px;
      min-height: 32px;
      background: #f5f7fa;
      border-radius: 8px 8px 8px 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      font-size: var(--set-font-size13);
      color: #202124;
      line-height: 20px;
      @include when('active') {
        background: #f0f7fe;
        color: #006cff;
        border: 1px solid #006cff;
      }
    }
    .select-cell {
      @include flex($justify: center, $align: center);
      padding: 6px;
      width: 78px;
      min-width: 78px;
      min-height: 32px;
      background: #f5f7fa;
      border-radius: 8px 8px 8px 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      font-size: var(--set-font-size13);
      color: #202124;
      line-height: 20px;
      @include when('active') {
        background: #f0f7fe;
        color: #006cff;
        outline: 1px solid #006cff;
      }
    }
  }
}
.agent-empty {
  margin-top: 24px;
}
</style>
